import {
  API_ENDPOINT,
  type ClientApiV1CourseGiftsSentQueryString,
  useClientApiV1CourseGiftsSentQuery,
} from '../../resources/@types/courseSchema';
import useQueryOptionWithUserId from '../hooks/useQueryOptionWithUserId';

interface UseClientV1CourseGiftsSentQuery {
  params: ClientApiV1CourseGiftsSentQueryString;
  options?: Parameters<typeof useClientApiV1CourseGiftsSentQuery>[0]['options'];
}

export function useCourseGiftsSentQuery({ params, options }: UseClientV1CourseGiftsSentQuery) {
  const { queryKey, url } = useQueryOptionWithUserId(
    API_ENDPOINT.CLIENT_V1_COURSE_GIFTS_SENT,
    params,
  );

  return useClientApiV1CourseGiftsSentQuery({
    queryKey,
    url,
    options,
  });
}

export const getCourseGiftsSentQueryKey = (params: ClientApiV1CourseGiftsSentQueryString) => {
  const { queryKey } = useQueryOptionWithUserId(API_ENDPOINT.CLIENT_V1_COURSE_GIFTS_SENT, params);

  return queryKey;
};
